import styled, { css } from 'styled-components';

export const HeaderLink = styled.a`
  ${({ theme }) => css`
    color: ${theme.colors.neutralSilver70};

    &:hover {
      color: ${theme.colors.neutralSilver70};
    }
  `}
`;

/* Flat background on the design system's --color-page (#f3f5f6).
   It was #f8f9fa plus the savings.club mark as a 460px background-image at
   `100% 450px` with fixed attachment — the crop left the mark floating out of any
   alignment, reading as a grey smudge behind the card rather than as branding.
   The flow carries no background mark at all now. */
export const Main = styled.main`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  background-color: #f3f5f6;
`;

export const Container = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    min-height: 100vh;
  `}
`;
